import { instanceOEF } from './api'

export const TIPOS_LOG_USUARIO = {
  'INICIOU_CHECKOUT_ADA_SEGUNDA_ASSINATURA': 'INICIOU_CHECKOUT_ADA_SEGUNDA_ASSINATURA',
  'INICIOU_CHECKOUT_ADA_REATIVAR': 'INICIOU_CHECKOUT_ADA_REATIVAR',
  'INICIOU_CHECKOUT_ADA_RENOVACAO': 'INICIOU_CHECKOUT_ADA_RENOVACAO',
  'INICIOU_CHECKOUT_ADA_UPGRADE': 'INICIOU_CHECKOUT_ADA_UPGRADE'
}

export const criarUsuarioLog = tipoLog => {
  if ( !Object.values( TIPOS_LOG_USUARIO ).includes( tipoLog ) ) {
    throw new Error( `Tipo de log inválido: ${tipoLog}` )
  }

  return instanceOEF.post(
    `/usuario-log/`,
    { 'tipo_evento': tipoLog }
  )
}
